/**
 * @fileoverview POST handler for the "/alloys/:provider/agentic/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { postAlloysProviderAgenticAppGroupIdCacheKeys } from "./constants";
import type {
  PostAlloysProviderAgenticAppGroupIdProps,
  PostAlloysProviderAgenticAppGroupIdResult,
  PostAlloysProviderAgenticErrors,
} from "./types";

export const postAlloysProviderAgenticAppGroupId = reactQueryMutationAdapter(
  postAlloysProviderAgenticAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAlloysProviderAgenticErrors>()(
    (props: PostAlloysProviderAgenticAppGroupIdProps): Promise<PostAlloysProviderAgenticAppGroupIdResult> => {
      return fetch(
        `/alloys/${props.provider}/agentic/${props.appGroupId}`,
        "POST",
        {
          api_key: props.apiKey,
          use_vertex_ai: props.useVertexAi ?? undefined,
          vertex_project_id: props.vertexProjectId ?? undefined,
          workspace_name: props.workspaceName ?? undefined,
          project_name: props.projectName ?? undefined,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
